"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MobilePlaceholder = exports.Subheading = exports.Heading = exports.ContentWrapper = exports.Wrapper = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _gridContainer = require("../grid-container");

var _typography = require("../typography");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Wrapper = (0, _styledComponents["default"])(_gridContainer.GridContainerWithBackground).withConfig({
  displayName: "counterstyles__Wrapper",
  componentId: "oi6adg-0"
})(["height:calc(100vw * 1.05);min-height:350px;max-height:500px;@media ", "{max-height:676px;}"], function (props) {
  return props.theme.queries.desktopAndUp;
});
exports.Wrapper = Wrapper;
var ContentWrapper = (0, _styledComponents["default"])('div').withConfig({
  displayName: "counterstyles__ContentWrapper",
  componentId: "oi6adg-1"
})(["padding:57px 0 0 0;grid-column:main-start / main-end;display:flex;flex-direction:column;justify-content:flex-start;align-items:center;@media ", "{padding:49px 0 0 0;}"], function (props) {
  return props.theme.queries.desktopAndUp;
});
exports.ContentWrapper = ContentWrapper;
var Heading = (0, _styledComponents["default"])(_typography.Heading).withConfig({
  displayName: "counterstyles__Heading",
  componentId: "oi6adg-2"
})(["display:", ";@media ", "{display:", ";}color:", ";"], function (props) {
  return props.hide === 'mobile' ? 'none' : 'block';
}, function (props) {
  return props.theme.queries.desktopAndUp;
}, function (props) {
  return props.hide === 'desktop' ? 'none' : 'block';
}, function (props) {
  return props.theme.colors.slate.base;
});
exports.Heading = Heading;
var MobilePlaceholder = (0, _styledComponents["default"])(_typography.Title).withConfig({
  displayName: "counterstyles__MobilePlaceholder",
  componentId: "oi6adg-3"
})(["display:block;padding-top:14px;padding-bottom:21px;color:", ";text-decoration:underline;@media ", "{display:none;}"], function (props) {
  return props.theme.colors.slate.base;
}, function (props) {
  return props.theme.queries.desktopAndUp;
});
exports.MobilePlaceholder = MobilePlaceholder;
var Subheading = (0, _styledComponents["default"])(_typography.Subheading).withConfig({
  displayName: "counterstyles__Subheading",
  componentId: "oi6adg-4"
})(["display:", ";color:", ";--font-size-min:", "rem;--font-size-max:", "rem;--font-weight:500;@media ", "{display:", ";}"], function (props) {
  return props.hide === 'mobile' ? 'none' : 'block';
}, function (props) {
  return props.theme.colors.slate.lighter;
}, 18 / 16, 18 / 16, function (props) {
  return props.theme.queries.desktopAndUp;
}, function (props) {
  return props.hide === 'desktop' ? 'none' : 'block';
});
exports.Subheading = Subheading;